import constant from "../../constant";
const resource = constant.api + "sales";

const state = {
  cart: {},
  items: [],
  sales: [],
  sale: {},
  statisticsReport: [],
  caisseStatistics: {},
};

// getters
const getters = {
  getCart: (state) => {
    return state.cart;
  },
  getItems: (state) => {
    return state.items;
  },
  getStatisticsReport: (state) => {
    return state.statisticsReport;
  },
  getCaisseStatistics: (state) => {
    return state.caisseStatistics;
  },
  getAll: (state) => {
    return state.sales;
  },
  getSale: (state) => {
    return state.sale;
  },
};

// actions
const actions = {
  async storeItem({ commit, dispatch }, data) {
    const response = await this._vm.$api.create(`${resource}_items`, data, {
      confirm: false,
    });
    let items = [];
    if (Array.isArray(response)) {
      items = response;
    } else if (response && Array.isArray(response.data)) {
      items = response.data;
    } else if (response?.data?.data && Array.isArray(response.data.data)) {
      items = response.data.data;
    }
    commit("cart/setItems", items, { root: true });

    const message = response?.message || "Item ajouté au panier";
    const status = response?.status || "success";
    dispatch("notification/store", { message, status }, { root: true });
    commit("cart/setItem", {}, { root: true });
  },

  async store({ commit, dispatch }, data) {
    const response = await this._vm.$api.create(resource, data);
    const responseData = response?.data || response;
    const sale = responseData?.data || responseData || {};
    commit("setSale", sale);
    const message = responseData?.message;
    const status = responseData?.status;
    dispatch("notification/store", { message, status }, { root: true });
    if (status === "success") {
      commit("setItems", []);
      try {
        await dispatch("getAll");
      } catch (error) {
        console.error("Error refreshing sales after create", error);
      }
    }
    return responseData;
  },

  async getAll({ commit }) {
    const response = await this._vm.$api.fetch(resource);
    const data = Array.isArray(response) ? response : response?.data || [];
    commit("setAll", data);
    return data;
  },

  async getSale({ commit }) {
    const response = await this._vm.$api.fetch(resource);
    commit("setAll", response);
  },

  async show({ commit }, reference) {
    const response = await this._vm.$api.show(`${resource}/${reference}`);
    const data = response?.data || response || {};
    commit("setSale", data);
    return data;
  },

  async update({ commit, dispatch }, { reference, data }) {
    const response = await this._vm.$api.update(
      `${resource}/${reference}`,
      data
    );
    await dispatch("getAll");
    return response;
  },

  async destroy({ commit, dispatch }, reference) {
    const response = await this._vm.$api.delete(`${resource}/${reference}`);
    await dispatch("getAll");
    return response;
  },

  async getItems({ commit }) {
    const response = await this._vm.$api.fetch(`${resource}_items`);
    let items = [];
    if (Array.isArray(response)) {
      items = response;
    } else if (response && Array.isArray(response.data)) {
      items = response.data;
    } else if (response?.data?.data && Array.isArray(response.data.data)) {
      items = response.data.data;
    }
    commit("cart/setItems", items, { root: true });
  },

  async addToCart({ commit }, data) {
    return await commit("setItem", data);
  },

  async fetchAllStatistics({ commit }, data) {
    try {
      const response = await this._vm.$api.instance.post(
        `${resource}_statistics_report`,
        data
      );
      const reportData =
        response?.data?.data ||
        response?.data ||
        (Array.isArray(response?.data) ? response.data : []);
      commit("setStatisticsReport", reportData);
      return reportData;
    } catch (error) {
      console.error("Error fetching statistics:", error);
      commit("setStatisticsReport", []);
      throw error;
    }
  },

  async fetchCaisseStatistics({ commit }) {
    try {
      // Use global statistics endpoint (not seller-specific)
      const response = await this._vm.$api.instance.get(
        "/api/statistics/total/todays"
      );
      // The API returns data directly or nested in data property
      const statsData = response?.data || response || {};
      commit("setCaisseStatistics", statsData);
      return statsData;
    } catch (error) {
      console.error("Error fetching caisse statistics:", error);
      commit("setCaisseStatistics", {});
      throw error;
    }
  },
};

// mutations
const mutations = {
  async setItems(state, data) {
    return (state.items = data);
  },

  setSales(state, data) {
    state.sales = Array.isArray(data) ? data : [];
  },

  async setItem(state, data) {
    return (state.item = data);
  },

  setStatisticsReport(state, data) {
    state.statisticsReport = Array.isArray(data) ? data : [];
  },
  setCaisseStatistics(state, data) {
    state.caisseStatistics = data || {};
  },
  setAll(state, data) {
    state.sales = Array.isArray(data) ? data : [];
  },
  setSale(state, data) {
    state.sale = data || {};
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
